import { render } from "./patient_list_page.vue?vue&type=template&id=82e823a0"
import script from "./patient_list_page.vue?vue&type=script&lang=js"
export * from "./patient_list_page.vue?vue&type=script&lang=js"

import "./patient_list_page.vue?vue&type=style&index=0&id=82e823a0&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__